import AssociatedPropertiesSelectorContainer from './containers/AssociatedPropertiesSelectorContainer'

export default AssociatedPropertiesSelectorContainer
